import { render, staticRenderFns } from "./AdditionalCost.vue?vue&type=template&id=22f6ca02&scoped=true"
import script from "./AdditionalCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdditionalCost.vue?vue&type=style&index=0&id=22f6ca02&prod&scoped=true&lang=css"
import style1 from "./AdditionalCost.vue?vue&type=style&index=1&id=22f6ca02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6ca02",
  null
  
)

export default component.exports